import { useEffect } from 'react';
import { useFlow } from '../utilities/useFlow';

export const ThemeSwitcher: React.FC = () => {
  const flow = useFlow();

  useEffect(() => {
    const bodyElement = document.body;

    bodyElement.classList.remove('keepr-theme', 'stannes-theme');

    if (flow === 'Keepr') {
      bodyElement.classList.add('keepr-theme');
    } else if (flow === 'St Annes') {
      bodyElement.classList.add('stannes-theme');
    }
  }, [flow]);

  return null;
};
